import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {},
  titleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: theme.palette.black.dark,
    fontSize: '22px',
    fontWeight: 600,
  },
  icon: {
    marginRight: '5px'
  },
  partTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: theme.palette.primary.primary500,
    fontWeight: 600,
    marginBottom: '12px',
    '& span': {
      marginLeft: '7px'
    }
  },
  tiersWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '21px',
    marginBottom: '32px'
  },
  attributsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom:'25px'
  },
  titleTiers: {
    color: theme.palette.grey.grey500,
    fontSize: '14px',
    fontWeight: 600,
  },
  tiers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#FFF',
    boxShadow: '0px -1px 0px 0px #ECECEC inset',
    height: '56px',
    width: 'auto',
    padding: '21px 14px',
    marginTop: '15px',
    borderRadius: '12px'
  },
  tiersInfo: {
    fontSize: '12px',
    color: theme.palette.black.dark
  },
  associe: {
    display:'flex',
    alignItems:'center',
    borderRadius: '30px',
    height: '28px',
    padding: '6px 10px',
    background: theme.palette.primary.primary800,
    color: 'white',
    fontWeight: 600,
    fontSize: '12px',
    '& img':{
      marginRight: '7px'
    }
  },

  referentText: {
    fontSize: '14px',
    color: theme.palette.grey.grey500,
    marginBottom: '19px'
  },
  referentsWrapper: {

  },
  referentInputWrapper: {
    marginBottom: '21px'
  },
  referentList: {

  },
  referentListTitle: {
    fontSize: '14px',
    color: theme.palette.grey.grey500,
    fontWeight: 600,
    marginBottom: '14px'
  },
  referentListItem: {
    display: 'flex',
    alignItems: 'center',
  },
  referentItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    width: '350px'
  },
  referentEmail: {
    marginLeft: '7px',
    marginRight: '7px',
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey700
  },
  deleteReferentButton: {
    color: theme.palette.error.error500,
    fontSize: '12px',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: 'auto',
    '&:hover': {
      color: theme.palette.error.error600,
    },
    '&:active': {
      color: theme.palette.error.error400
    }
  },
  container: {
    border: `1px solid ${theme.palette.grey.grey100}`,
    background: 'rgba(242, 243, 247, 0.20)',
    margin: '14px 26px',
    padding: '16px',
    maxHeight: '200px',
    overflow: 'auto',
  },

}));

export default useStyles;
